import { Component, OnInit } from '@angular/core';
import { DashboardSectionStatus } from '../dashboard.component';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
//import countries from '../../assets/data/countries.json';
import plantree from '../../../assets/data/plan-tree.json';

@Component({
  selector: 'app-my-dashboard-tab3',
  templateUrl: './my-dashboard-tab3.component.html',
  styleUrls: ['./my-dashboard-tab3.component.scss']
})
export class MyDashboardTab3Component implements OnInit {
  SectionTitle = "My Daily Life"
  SectionStatus = DashboardSectionStatus
  DailyLifeInfo = 'John, why no take a few minutes to review the items value listed in your plan?'

  DailyLifeNumbers = [
    {
      circle: 'upToDate',
      number: 12,
      SectionStatus: DashboardSectionStatus[0]
    },
    {
      circle: 'toReview',
      number: 6,
      SectionStatus: DashboardSectionStatus[1]
    },
    {
      circle: 'toAdd',
      number: 3,
      SectionStatus: DashboardSectionStatus[2]
    },
  ]

  reviewStatusPerSection = [];
  constructor(private zenPlansData:ZenplansTestDataProviderService) { 
  }

  async ngOnInit() {
    let sectionStatus = await this.zenPlansData.getPlanCategoryStatus("my daily life");
    this.DailyLifeNumbers[0].number= sectionStatus["upToDates"];
    this.DailyLifeNumbers[1].number= sectionStatus["forReviews"];
    this.DailyLifeNumbers[2].number= sectionStatus["missing"];
    this.reviewStatusPerSection = sectionStatus["reviewCodes"];
  }

  async getSectionStatus(){

  }

}
